import { getHotAreaId } from './common';
export var hotAreaNodeMap = new Map();
export function setHotAreaNode(key, node) {
    hotAreaNodeMap.set(key, node);
}
export function deleteHotAreaNode(key) {
    return hotAreaNodeMap.delete(key);
}
export function getHotAreaNode(key) {
    return hotAreaNodeMap.get(key) || document.getElementById(getHotAreaId(key));
}
if (typeof window !== 'undefined' && !window.__hotAreaInstanceNodeMap) {
    Object.defineProperty(window, '__hotAreaInstanceNodeMap', {
        get: function () {
            return hotAreaNodeMap;
        },
    });
}
//# sourceMappingURL=hotAreaNode.js.map